import { useRef, useState } from 'react';
import { setSchedulePublicEndIntervalDate } from 'entities/index';
import { useAppDispatch, useAppSelector } from 'shared/lib';

export const useScroll = () => {
  const containerScheduleRef = useRef<HTMLDivElement>(null);
  const dateHeaderRef = useRef<HTMLDivElement>(null);
  const [isScrolledDown, setIsScrolledDown] = useState<boolean>(false);

  const { endIntervalDate } = useAppSelector(
    (state) => state.schedulePublicReducer,
  );

  const dispatch = useAppDispatch();

  const loadMoreData = () => {
    dispatch(setSchedulePublicEndIntervalDate(endIntervalDate.add(10, 'day')));
  };

  const handleScroll = () => {
    if (containerScheduleRef.current && dateHeaderRef.current) {
      dateHeaderRef.current.scrollLeft =
        containerScheduleRef.current.scrollLeft;

      const { scrollLeft, scrollWidth, clientWidth } =
        containerScheduleRef.current;
      if (scrollLeft + clientWidth >= scrollWidth - scrollWidth * 0.05) {
        loadMoreData();
      }
    }
  };

  return {
    containerScheduleRef,
    dateHeaderRef,
    isScrolledDown,
    setIsScrolledDown,
    handleScroll,
  };
};
